import React, { Component } from "react";
import Auth from "core/services/authToken";

export default class IdleWatch extends Component {
  static defaultProps = {
    events: ["mousemove", "mousedown", "keydown", "touchstart", "scroll"],
    timeout: 60 * 60 * 1000,
  };

  componentDidMount() {
    if (Auth.checkTokens()) {
      this.attachEvents();
      this.setTimeout();
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.timeout && Auth.checkTokens()) {
      this.attachEvents();
      this.setTimeout();
    }
  }

  componentWillUnmount() {
    this.removeEvents();
    clearTimeout(this.timeout);
  }

  setTimeout() {
    const self = this;
    this.timeout = setTimeout(() => {
      self.props.onIdle();
      clearTimeout(self.timeout);
    }, this.props.timeout);
  }

  attachEvents() {
    this.props.events.forEach((e) => {
      window.addEventListener(e, this.handleEvent.bind(this), true);
    });
  }

  removeEvents() {
    this.props.events.forEach((e) => {
      window.removeEventListener(e, this.handleEvent.bind(this), true);
    });
  }

  handleEvent() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (Auth.checkTokens()) {
      this.setTimeout();
    }
  }

  render() {
    return null;
  }
}
